import React, { useContext, useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import { Context } from "../contexts/AppContext";
import { QRCodeSVG } from "qrcode.react";
import { FaDownload } from "react-icons/fa";

function QrCodeModal() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const qrRef = useRef();

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "90%",
      border: "1px solid #000000",
      backgroundColor: "#1F2937",
      borderRadius: "12px",
      padding: "20px",
      textAlign: "center",
      color: "white",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.5)",
    },
  };

  const closeModal = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: { ...prevState.modalData, type: null, isOpen: false },
    }));
  };

  // 🔥 Current URL (important)
    const qrUrl = 'https://galleries.vidmantra.com/69cb839e7fb976663acd3a6e'//window.location.href;
    

   
  

  return (
    <Modal
      isOpen={modalOpen.isOpen && modalOpen.type === "QrCodeModal"}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <h2 className="text-lg font-semibold mb-4">Scan QR Code</h2>

      {/* QR */}
      <div
        ref={qrRef}
        className="relative flex items-center justify-center"
      >
        <QRCodeSVG value={qrUrl} size={220} />

        
      </div>

    

    
    </Modal>
  );
}

export default QrCodeModal;